export class Warehouse {
	static readonly BES = "BES";
	static readonly RAT = "RAT";

	static values(): string[] {
		return [Warehouse.BES, Warehouse.RAT];
	}
}
